export class EventiDirette {
    portale = '';
    extra_time: number = null;
    id: number = null;
    id_diretta: number = null;
    id_evento: number = null;
    id_wp_player1: number = null;
    id_wp_player2: number = null;
    id_wp_team1: number = null;
    id_wp_team2: number = null;
    last_modified: Date = null;
    native_main_event: boolean = null;
    main_event: boolean = null;
    minuto: number = null;
    note: string = null;
    stato_diretta: number = null;
    abbreviazione: string = null;
    descrizione: string = null;
    icona: string = null;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/eventi-dirette.ts